import {TimelineMax} from 'gsap';
import Tombola from 'tombola';
import Swiper from 'swiper';
import data from './data';
// import rellaxStuff from './intro-rellax';
import CustomSelect from './custom-select';
import {scrollTo, getViewport} from './scroll-to';
import analyticsEvent from './analyticsEvent';
import * as VanillaSharing from 'vanilla-sharing';
import meta from './meta';
import Responsive from 'mkh-responsive';
const responsive = new Responsive();
import CustomEase from './CustomEase';
import ieFix from './ie-fix';

class LotteryPlay {

    constructor(icon) {
        this.icon = icon;
        this.svgIcon = icon.querySelector('svg');
        this.clone = this.svgIcon.cloneNode(true);
        this.svgArr = [];
        this.animationArr = [];
        this.stoped = false;
    }

    play(count = 20, icon, callback) {
        if (this.stoped) {
            this.stop();
        }


        this.stoped = true;

        for (let index = 0; index < count; index++) {
            const svg = this.clone.cloneNode(true);
            const use = svg.querySelector('use');

            if (index + 1 < count) {
                use.setAttribute('xlink:href', tombola.item(icons));
            } else {
                use.setAttribute('xlink:href', icon);
            }

            this.svgArr.push(svg);
        }

        if (this.svgIcon) {
            this.icon.removeChild(this.svgIcon);
            this.svgIcon = null;
        }

        /* this.svgArr.forEach((svg, index) => {
            this.icon.appendChild(svg);
            const delay = 100 * index / 1000;
            let tl = new TimelineMax({
                delay,
                repeat: 0,
                paused: false
            });

            tl.set(svg, {y: '-150%'});

            const onComplete = () => {
                if (svg.parentNode === this.icon) {
                    this.icon.removeChild(svg);
                }
            };

            if (count === 1) {
                tl.set(svg, {y: '0%'});
            } else if (index < this.svgArr.length - 3) {
                tl.to(svg, 0.3, {y: '150%', onComplete});
            } else if (index === this.svgArr.length - 3) {
                tl.to(svg, 0.4, {y: '150%', onComplete});
            } else if (index === this.svgArr.length - 2) {
                tl.to(svg, 0.5, {y: '150%', onComplete});
            } else if (index === this.svgArr.length - 1) {
                tl.to(svg, 1.8, {y: '0%', ease: window.Elastic.easeOut.config(1, 0.3), onComplete: () => {
                    tl.kill();
                    tl = null;

                    if (typeof callback === 'function') {
                        callback.call(null);
                    }
                }});
            }

            this.animationArr.push(tl);
        }); */
        TimelineMax, callback;

        this.svgArr.forEach(svg => {
            this.icon.appendChild(svg);
        });
        
        const lastsvg = this.svgArr.pop();
        this.icon.removeChild(lastsvg);

        const time = this.svgArr.length * 0.1;

        let tl = new TimelineMax({
            repeat: 0,
            paused: false
        });

        const y = this.svgArr.length > 0 ? 100 / this.svgArr.length + '%' : '0%';

        tl.set(this.icon, {y: '-100%'});
        

        tl.to(this.icon, time, {
            y,
            // ease: window.Power1.easeIn,
            ease: CustomEase.create('custom', 'M0,0,C0.988,0.826,0.924,0.862,1,1'),
            onComplete: () => {
                while(this.icon.firstChild) {
                    this.icon.removeChild(this.icon.firstChild);
                }

                tl.set(this.icon, {y: '-100%'});
                this.icon.appendChild(lastsvg);

                tl.to(this.icon, 1.8, { 
                    y: '0%',
                    ease: window.Elastic.easeOut.config(1, 0.3),
                    onComplete: () => {
                        tl.kill();
                        tl = null;

                        if (typeof callback === 'function') {
                            callback.call(null);
                        }
                    }
                });
            }
        });

        
    }

    stop() {
        this.svgArr.forEach(svg => {
            if (svg.parentNode === this.icon) {
                this.icon.removeChild(svg);
            }
        });

        this.svgArr.splice(0, this.svgArr.length);

        this.animationArr.forEach(tl => {
            if (tl) {
                tl.kill();
            }
        });

        this.animationArr.splice(0, this.animationArr.length);
        this.stoped = false;
    }
}

const slideTemplate1 = require('pug-loader!../includes/client-pug/swiper-slide.pug');
const slideTemplate2 = require('pug-loader!../includes/client-pug/swiper-slide-2.pug');
const events = JSON.parse(JSON.stringify(data.events));
const tombola = new Tombola;
const icons = Object.keys(events)
    .reduce((mem, event) => mem.concat(events[event].map(item => item.icon)), [])
    .filter((x, i, a) => a.indexOf(x) === i);



const init = root => {
    const swiperContainer = root.querySelector('.swiper-container');
    const lotteryContainer = root.querySelector('.lottery');
    const bubbleElement = root.querySelector('.bubble');
    const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    const icon1 = root.querySelector('[data-lottery-icon="1"]');
    const icon2 = root.querySelector('[data-lottery-icon="2"]');
    const icon3 = root.querySelector('[data-lottery-icon="3"]');
    const playButtons = Array.from(root.querySelectorAll('.lottery-play'));
    const citySelectElement = root.querySelector('#city-select');
    const cityLabel = Array.from(root.querySelectorAll('[data-city-label]'));
    const swiperButtonPrev = swiperContainer.querySelector('.swiper-button-prev');
    const swiperButtonNext = swiperContainer.querySelector('.swiper-button-next');

    let articles;
    let swiper;
    let introRellaxDestroy;
    let infoAnimation;
    let filter = '';
    let citySelect;

    if (citySelectElement) {
        citySelect = new CustomSelect(citySelectElement);
        citySelect.on('change', opt => {
            filter = opt.value;

            setTimeout(() => {
                analyticsEvent('Select', 'click', 'Filter: ' + opt.value);
            }, 10);
        });
    }


    const loadArticlesImages = () => {
        articles.forEach(article => {
            const img = new Image();
            img.src = article.picture.original;
        })
    };


    const randomInteger = (min, max) => {
        return Math.floor(min + Math.random() * (max + 1 - min));
    };

    const randomArticles = () => {
        const keys = filter ? Object.keys(events).filter(item => item.search(new RegExp('^' + filter + '\\d*')) !== -1) : Object.keys(events);
        const index = randomInteger(0, keys.length - 1);

        return JSON.parse(JSON.stringify(events[keys[index]]));
    };




    const lotteryScreens = [
        new LotteryPlay(icon1),
        new LotteryPlay(icon2),
        new LotteryPlay(icon3)
    ];

    const lottery = {
        play: (delay = true, callback) => {
            lotteryScreens.forEach((lp, index) => {
                const icon = articles[index].icon;

                if (delay) {
                    switch (index) {
                        case 0: lp.play(Math.round(20 * 1), icon); break;
                        case 1: lp.play(Math.round(35 * 1), icon); break;
                        case 2: lp.play(Math.round(50 * 1), icon, callback.bind(null)); break;
                    }
                } else {
                    lp.play(1, icon);
                }
            });
        }
    };

    const getMobileArticles = articles => {
        const result = [];

        articles.forEach((article, index) => {
            const article1 = JSON.parse(JSON.stringify(article));
            const article2 = JSON.parse(JSON.stringify(article));
            article1.index = index;

            article2.second = true;
            article2.index = index;

            result.push(article1);
            result.push(article2);
        });

        return result;
    }

    const hideSwiperButtons = () => {
        const buttons = [swiperButtonPrev, swiperButtonNext];

        buttons.forEach(button => {
            button.style.display = 'none';
        });
    }

    const showSwiperButtons = () => {
        const buttons = [swiperButtonPrev, swiperButtonNext];

        buttons.forEach(button => {
            button.style.display = '';
        });
    }

    const addArticlesToWrapper = (type = 1) => {
        const fSlideTemplate = type === 2 ? slideTemplate2 : slideTemplate1;
        const fArticles = type === 2 ? getMobileArticles(articles) : articles;

        fArticles.forEach(article => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';

            slide.innerHTML = fSlideTemplate({
                article
            });

            swiperWrapper.appendChild(slide);
        });
    };

    const removeArticlesFromWrapper = () => {
        while (swiperWrapper.firstChild) {
            swiperWrapper.removeChild(swiperWrapper.firstChild);
        }
    };


    const initPaginator = (type = 1) => {

        if (!swiper || !swiperWrapper) {
            return;
        }


        const links = [...swiperWrapper.querySelectorAll('[data-swiper-to]')];

        links.forEach(link => {
            link.addEventListener('click', () => {
                const index = type === 2 ? Math.floor(link.dataset.swiperTo * 2) : link.dataset.swiperTo;
                swiper.slideTo(index);
            });
        })
    };

    const initSwiper = (type = 1, callback) => {
        if (swiper) {
            swiper.destroy();
            swiper = null;
            removeArticlesFromWrapper();
        }
        
        addArticlesToWrapper(type);

        if (type === 2) {
            hideSwiperButtons();
        } else {
            showSwiperButtons();
        }

        const swiperOptions = {
            direction: 'horizontal',
            loop: false,
            autoHeight: false,
            speed: 500,
            spaceBetween: window.innerWidth * 0.2,
            mousewheel: false,
            effect: 'fade',
            init: false,
            navigation: {
                nextEl: swiperButtonNext,
                prevEl: swiperButtonPrev
            }
        };

        if (type === 2) {
            swiperOptions.effect = 'slide';
            swiperOptions.autoHeight = false;
            swiperOptions.spaceBetween = 20;
            swiperOptions.navigation = false;
        }

        swiper = new Swiper(swiperContainer, swiperOptions);


        if (type === 2) {
            swiper.on('init', () => {
                initPaginator(type);

                if (typeof callback === 'function') {
                    callback.call(null);
                }
            });
        } else {
            swiper.on('init', () => {
                if (typeof callback === 'function') {
                    callback.call(null);
                }
            });
        }

        setTimeout(() => {
            swiper.update();
        }, 100);

        swiper.init();
    };

    const info = {
        destroy: () => {
            if (swiper) {
                swiper.destroy();
                swiper = null;
            }

            if (typeof introRellaxDestroy === 'function') {
                introRellaxDestroy();
                introRellaxDestroy = null;
            }

            while (swiperWrapper.firstChild) {
                swiperWrapper.removeChild(swiperWrapper.firstChild);
            }
        },
        show: () => {
            info.destroy();
            cityLabel.forEach(el => el.innerText = articles[0].city);

            // articles.forEach(article => {
            //     const slide = document.createElement('div');
            //     slide.className = 'swiper-slide';

            //     slide.innerHTML = slideTemplate({
            //         article
            //     });

            //     swiperWrapper.appendChild(slide);
            // });

            const initShare = () => {
                const shareButtons = [...root.querySelectorAll('.share__item')];
                
                if (!shareButtons.length) {
                    return; 
                }

                shareButtons.forEach(button => {
                    const id = button.dataset.shareId;

                    if (typeof id === 'string') {
                        const article = articles.find(article => article.share.id === id);
    
                        const shareOptions = {
                            url: meta.shareurl + '?id=' + article.share.id,
                            title: article.share.title,
                            description: article.share.description,
                            image: article.share.image,
                            isVkParse: false,
                            fbAppId: meta.fbappid
                        };
    
                        button.addEventListener('click', () => {
                            if (button.dataset.social === 'all' && navigator.share !== undefined) {
                                navigator.share({
                                    title: shareOptions.title,
                                    url: shareOptions.url
                                });
                            } else {
                                VanillaSharing[button.dataset.social](shareOptions);
                            }
    
                            setTimeout(() => {
                                analyticsEvent('Share', 'click', 'Social: ' + button.dataset.social, [
                                    'city',
                                    `${article.city} ${article.share.title}`
                                ]);
                            }, 10);
                        });
                    }
                });
            };

            
            const init = () => {
                ieFix.init();
                bubbleElement.classList.add('bubble--hidden');

                setTimeout(() => {
                    bubbleElement.classList.remove('bubble--hidden');
                }, 3000);

                initShare();

                const trackingElements = [...root.querySelectorAll('[data-event][data-event-category][data-event-label]')];

                if (trackingElements.length > 0) {
                    trackingElements.forEach(trackingElem => {
                        trackingElem.addEventListener(trackingElem.getAttribute('data-event'), () => {
                            analyticsEvent(
                                trackingElem.getAttribute('data-event-category'),
                                trackingElem.getAttribute('data-event'),
                                trackingElem.getAttribute('data-event-label')
                            );
                        });
                    });
                }
            }

            responsive.register('md-left', () => {
                initSwiper(2, init);
            });

            responsive.register('md-right', () => {
                initSwiper(1, init);
            });

        }
    };

    const play = (delay = true, scrollToCenter = false, loadImages = true) => {
        clearTimeout(infoAnimation);

        if (scrollToCenter) {
            scrollTo(lotteryContainer, 'center');
        }

        const articlesData = randomArticles();

        if (articlesData.length === 0) {
            return play(delay);
        }

        if (articlesData.length < 3) {
            articlesData.push(articlesData[0]);
            articlesData.push(articlesData[0]);
        }

        articles = [
            articlesData[0],
            articlesData[1],
            articlesData[2]
        ];

        if (loadImages) {
            loadArticlesImages();
        }

        const scrollToSwiper = () => {
            infoAnimation = setTimeout(() => {
                
                
                info.show();
                citySelect.show(articles[0].city);
                
                

                setTimeout(() => {
                    analyticsEvent('Lottery', 'win', 'Город: ' + articles[0].city);
                }, 10);

                if (delay) {
                    citySelectElement.classList.remove('ui-d-none');
                    document.body.dataset.lotteryFilter = true;

                    const viewport = getViewport(swiperContainer);
                    const viewportST = viewport.scrollTop;
                    document.body.dataset.gamePlay = true;
                    viewport.scrollTop = viewportST;


                    setTimeout(() => {
                        if (window.innerWidth > 768) {
                            scrollTo(swiperContainer, 'end');
                        } else {
                            scrollTo(swiperContainer);
                        }

                    }, 1200);
                }
            }, 10);
        };

        lottery.play(delay, scrollToSwiper);

        // infoAnimation = setTimeout(() => {
            // if (delay) {
            //     document.body.dataset.gamePlay = true; 
            // }
            
            // info.show();
            // citySelect.show(articles[0].city);
            // analyticsEvent('Lottery', 'win', 'Город: ' + articles[0].city);
            
            
            // if (delay) {
            //     citySelectElement.classList.remove('ui-d-none');
            //     document.body.dataset.lotteryFilter = true;

            //     setTimeout(() => {
            //         scrollTo(swiperContainer);
            //     }, 1200);
            // }
        // }, timeout);
    };


    playButtons.forEach(button => {
        const scrollToCenter = button.dataset.lotteryScroll;
        button.addEventListener('click', play.bind(null, true, scrollToCenter));
    })
    play(false, false, false);
    
    setTimeout(() => {
        citySelect.show('Любой Город');
    }, 10);
};


const destroy = () => {
    delete document.body.dataset.gamePlay;
};

export default {
    init,
    destroy
}


// WEBPACK FOOTER //
// ./js/lottery.js